import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { FeatureEnum } from 'src/app/enum/feature.enum';

const CONTROLLER = 'onBoardingViewed';
@Injectable({
  providedIn: 'root'
})
export class EnvelopeOnBoardingService {

  constructor(private http: HttpClient) {
  }

  public verifyViewed(feature: FeatureEnum): Observable<any> {
    return this.http.get(CONTROLLER.concat('?feature=' + feature))
      .pipe(
        map((response: boolean) => response),
        catchError(this.handleError)
      );
  }

  public maskAsViewed(feature: FeatureEnum, ignoreAlert: Boolean = false): Observable<any> {
    return this.http.post(CONTROLLER, { feature, ignoreAlert });
  }

  private handleError(errorResponse: Response) {
    console.log(errorResponse.statusText);
    return throwError(errorResponse || 'Server error');
  }
}
